import { render, staticRenderFns } from "./InstructionBD.vue?vue&type=template&id=642aadae&"
import script from "./InstructionBD.vue?vue&type=script&lang=js&"
export * from "./InstructionBD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports